<template>
    <div v-if="shouldRender && !isDismissed && isLoggedIn" id="global-notification" class="bg-primary text-white" style="position:relative;z-index:99999;">
        <div class="global-notification-wrap">
            <div v-html="banner" />
            <button class="global-notification-dismiss" @click="dismiss" aria-label="Dismiss">
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <line x1="18" y1="6" x2="6" y2="18" />
                    <line x1="6" y1="6" x2="18" y2="18" />
                </svg>
            </button>
        </div>
    </div>
</template>


<script>
import ServerContentMixin from '@/mixins/ServerContentMixin';
import { mapState } from 'vuex';

const STORAGE_KEY = 'global_notification_dismissed';
const CHECK_INTERVAL = 5 * 60 * 1000; // 5 minutes

export default {

    mixins: [ServerContentMixin],

    data() {
        return {
            banner: null,
            version: null,
            isDismissed: false,
            checkInterval: null,
        }
    },

    mounted() {
        this.fetchBanner();
        
        // Auto-check for banner updates every 5 minutes
        this.checkInterval = setInterval(() => {
            this.fetchBanner();
        }, CHECK_INTERVAL);
    },

    beforeDestroy() {
        if (this.checkInterval) {
            clearInterval(this.checkInterval);
        }
    },

    methods: {
        fetchBanner() {
            this.axios.get('/content/banner').then(res => {
                const newVersion = res.data?.title?.split('(')[1]?.replace(')', '').trim();
                
                // If version changed, reset dismissed state
                if (this.version && newVersion !== this.version) {
                    this.isDismissed = false;
                }
                
                this.banner = res.data.components[0]?.content;
                this.version = newVersion;
                
                this.checkDismissedState();
            }).catch(err => {
                console.error(err);
            });
        },

        checkDismissedState() {
            try {
                const dismissed = localStorage.getItem(STORAGE_KEY);
                if (dismissed === this.version) {
                    this.isDismissed = true;
                }
            } catch (e) {
                // localStorage not available
            }
        },

        dismiss() {
            this.isDismissed = true;
            try {
                localStorage.setItem(STORAGE_KEY, this.version);
            } catch (e) {
                // localStorage not available
            }
        },
    },

    computed: {
        ...mapState({
            isLoggedIn: state => state.account.isLoggedIn,
        }),
        shouldRender() {
            if (!this.banner) return false;

            return this.banner[0]?.content?.replaceAll('<p>', '').replaceAll('</p>', '').trim() !== '';
        }
    }
}
</script>   

<style lang="scss">

#global-notification {
    padding: 12px 0;
}

.global-notification-wrap {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    padding: 0 48px 0 16px;

    p {
        margin-bottom: 0;
        text-align: center;
        font-size: 15px;
    }
    a {
        color: inherit!important;
        text-decoration: underline!important;
    }
}

.global-notification-dismiss {
    all: unset;
    position: absolute;
    right: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 28px;
    border-radius: 6px;
    cursor: pointer;
    opacity: 0.7;
    transition: opacity 0.2s ease, background 0.2s ease;

    &:hover {
        opacity: 1;
        background: rgba(255, 255, 255, 0.15);
    }
}
</style>
